<template>
  <SlideSidebarContainer>
    <template #title>
      <UserIntroduceBox :user="user" />
    </template>

    <UserMenuNavbar />
  </SlideSidebarContainer>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import UserMenuNavbar from '@/components/user/UserMenuNavbar'
  import UserIntroduceBox from '@/components/user/UserIntroduceBox'

  export default {
    components: {
      SlideSidebarContainer,
      UserMenuNavbar,
      UserIntroduceBox,
    },

    computed: {
      ...mapGetters('user', ['user'])
    }
  }
</script>